var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kpmg-logout_svg__kpmg-logout",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 198.7 198.7",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".kpmg-logout_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "kpmg-logout_svg__st0",
    d: "M143.5 60.2c-12.4-8.7-15.9-7.6-16.7-3.9-1.5 8 7 9.2 15.4 16.3 12 10.1 18.9 24.7 20.2 41.8 1.4 18.3-4.8 33.2-15.7 45.6-12.6 12.6-26.7 20.1-44.5 21.7-16.6 0-35.4-6.7-48.1-19.4-25.2-25.2-22-68.1 4.3-92 10.9-9.9 19.6-8.3 17-15.4-1.3-3.6-3-7.6-22.9 7.1-31.2 25.2-35.8 77.8-5.3 108.2 15.2 15.2 35.1 21.1 55.1 21.1s35.1-7.4 50.3-22.6c14.7-14.7 19.6-32 19.6-52.9 0-20.8-11.3-43.3-28.7-55.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "kpmg-logout_svg__st0",
    d: "M102.4 108.2c2.8-.1 4.9-2.1 4.9-6.3V14c0-4.3-2.1-6.5-4.9-6.6-2.8-.1-5.1 2.4-5.1 6.7l.1 88c-.1 4.4 2.1 6.2 5 6.1z"
  })));
}

export default SvgKpmgLogout;